import { mutator } from 'satcheljs';
import store from '../store/Store';
import { pivotToggled } from '../actions/internalActions';

mutator(pivotToggled, actionMessage => {
    for (const pivot of store.enabledDisabledPivots) {
        if (pivot.InboxClassificationFilter === actionMessage.pivot.InboxClassificationFilter) {
            pivot.isEnabled = actionMessage.shouldEnable;
            return;
        }
    }
});
